import { SWReactIcons } from "@similarweb/icons";
import {
    ButtonVariant,
    primaryElementFont,
    setFilterButtonColor,
    setFilterButtonElementsColor,
} from "app/pages/sales-intelligence/sub-modules/signals/components/filters/shared/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled, { css } from "styled-components";

type ButtonProps = {
    isActive?: boolean;
    isDisabled?: boolean;
    withPlaceholder: boolean;
};

const getFilterButtonVariant = ({ isDisabled, withPlaceholder }: ButtonProps): ButtonVariant => {
    if (withPlaceholder || isDisabled) {
        return ButtonVariant.Placeholder;
    }

    return ButtonVariant.Default;
};

export const StyledFilterDropdownButton = styled(FlexRow)<ButtonProps>`
    ${primaryElementFont()};

    justify-content: space-between;
    align-items: center;
    column-gap: 12px;
    padding-bottom: 4px;
    min-width: 100%;
    cursor: ${(props: ButtonProps) => (props.isDisabled ? "not-allowed" : "pointer")};

    ${(props: ButtonProps) => setFilterButtonColor(getFilterButtonVariant(props))};

    ${(props: ButtonProps) =>
            props.withPlaceholder &&
            css`
                font-weight: 400;
                text-transform: lowercase;
            `};

    ${(props: ButtonProps) =>
            props.withPlaceholder && !props.isDisabled && setFilterButtonElementsColor(ButtonVariant.Default)};

    &:hover {
        ${(props: ButtonProps) => {
            if (!props.isActive && !props.isDisabled) {
                return setFilterButtonColor(ButtonVariant.Active);
            }
        }};
    }

    & * {
        font-family: inherit;
    }

    ${SWReactIcons} {
        display: inline-flex;
    }
`;
